import { render, staticRenderFns } from "./HarvestsTable.vue?vue&type=template&id=6b2338d2&lang=html&"
import script from "./HarvestsTable.vue?vue&type=script&lang=js&"
export * from "./HarvestsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports